import { formatRelativeTime } from "@saucer/core";
import type { LiveEvent } from "@saucer/core";

const VERBS: Record<LiveEvent["type"], string> = {
  view: "opened",
  download: "downloaded",
  upload: "uploaded",
  ready: "finished processing",
};

/** A quiet ticker: your links, being used, while you watch. */
export function LiveFeed({ events }: { events: LiveEvent[] }) {
  if (events.length === 0) return null;

  return (
    <section className="live">
      <span className="live__pulse" aria-hidden="true" />
      <ul className="live__list">
        {events.slice(0, 4).map((event) => (
          <li key={`${event.fileId}-${event.at}`} className="meta">
            <span className="mono">{event.slug}</span> {VERBS[event.type]}
            {event.country ? ` from ${event.country}` : ""} ·{" "}
            {formatRelativeTime(new Date(event.at).toISOString())}
          </li>
        ))}
      </ul>
    </section>
  );
}
